import { render, staticRenderFns } from "./users-edit.vue?vue&type=template&id=84559c40"
import script from "./users-edit.vue?vue&type=script&lang=js"
export * from "./users-edit.vue?vue&type=script&lang=js"
import style0 from "./users-edit.vue?vue&type=style&index=0&id=84559c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports